enum PORTFOLIO_SCREEN_TYPE {
  Intro = 'INTRO',
  Experience = 'EXPERIENCE',
}

export { PORTFOLIO_SCREEN_TYPE };
